import { render, staticRenderFns } from "./devicesDashboardExerciseForm.vue?vue&type=template&id=2c4ca6cc&scoped=true&xmlns=true"
import script from "./devicesDashboardExerciseForm.vue?vue&type=script&lang=js"
export * from "./devicesDashboardExerciseForm.vue?vue&type=script&lang=js"
import style0 from "./devicesDashboardExerciseForm.vue?vue&type=style&index=0&id=2c4ca6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4ca6cc",
  null
  
)

export default component.exports